module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fCFGb"))).then(() => parcelRequire('fThBo'));